import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { JSX } from 'react';
import { TextEyebrow } from '../../../v2/components/text-eyebrow';
interface Props {
  children: React.ReactNode;
}
export function MenuItemTitle(props) {
  const $ = _c(2);
  const {
    children
  } = props;
  let t0;
  if ($[0] !== children) {
    t0 = <div className="mt-4 mb-2 px-6 py-0"><TextEyebrow>{children}</TextEyebrow></div>;
    $[0] = children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}